import { $api } from "@/services/api";
import store from "@/store";
const state = {
  totalGR: {
    all: 0,
    inProcess: 0,
    waitingForApproval: 0,
    blockedInvoice: 0,
    waitingForCancelApproved: 0,
  },
  billingStatus: "",
  billingInterfaceStatus: "",
  fiApListSearchObj: {},
  billingCenterSearchObj: {},
  detailViewMode: "default",
};

const getters = {
  totalGR: (state) => state.totalGR,
  billingStatus: (state) => state.billingStatus,
  billingInterfaceStatus: (state) => state.billingInterfaceStatus,
  fiApListSearchObj: (state) => state.fiApListSearchObj,
  billingCenterSearchObj: (state) => state.billingCenterSearchObj,
  goodsReceiptDetailMode: (state) => state.detailViewMode,
};

const mutations = {
  updateFiApListSearchObj(state, obj) {
    state.fiApListSearchObj = obj;
  },
  updateBillingCenterSearchObj(state, obj) {
    state.billingCenterSearchObj = obj;
  },
  setTotalGR(state, total) {
    state.totalGR.all = total;
  },
  setInProcessGRCounter(state, total) {
    state.totalGR.inProcess = total;
  },
  setWaitingForApprovalGRCounter(state, total) {
    state.totalGR.waitingForApproval = total;
  },
  setBlockedInvoiceGRCounter(state, total) {
    state.totalGR.blockedInvoice = total;
  },
  setWaitingForCancelApprovedGRCounter(state, total) {
    state.totalGR.waitingForCancelApproved = total;
  },
  setGoodsReceiptDetailMode(state, mode) {
    state.detailViewMode = mode || "default";
  },
  setStatusForGR(state, status) {
    state.billingStatus = status;
  },
  setInterfaceStatusForGR(state, status) {
    state.billingInterfaceStatus = status
  },
  clearStatusForGR(state) {
    state.billingStatus = "";
  },
  clearInterfaceStatusForGR(state) {
    state.billingInterfaceStatus = "";
  }
};

const actions = {
  updateFiApListSearchObj({ commit }, obj) {
    commit("updateFiApListSearchObj", obj);
  },
  updateBillingCenterSearchObj({ commit }, obj) {
    commit("updateBillingCenterSearchObj", obj);
  },
  updateStatusForGR({ commit }, status) {
    commit("setStatusForGR", status);
  },
  updateInterfaceStatusForGR({ commit }, status) {
    commit("setInterfaceStatusForGR", status);
  },
  clearFiApListSearchObj({ commit }) {
    commit("updateFiApListSearchObj", {});
  },
  clearBillingCenterSearchObj({ commit }) {
    commit("updateBillingCenterSearchObj", {});
  },
  clearStatusForGR({ commit }) {
    commit("clearStatusForGR");
  },
  clearInterfaceStatusForGR({ commit }) {
    commit("clearInterfaceStatusForGR");
  },
  async getTotalGR({ commit }) {
    const buyerFilter = store.getters.isSpecialUser
      ? {}
      : { buyer_employee_code: store.getters.user.empCodeHC };

    const baseInProcessStatus = {
      "status[$in][0]": "Waiting for Verify",
      "status[$in][1]": "Waiting for Submit Approval",
      "status[$in][2]": "Error",
      "status[$in][3]": "Reworked",
      is_active: true,
    };

    const buildParams = (...sources) => Object.assign({}, ...sources);

    const inProcessParams = buildParams(baseInProcessStatus, buyerFilter, {
      "cancel_status[$in][0]": "NULL",
      "cancel_status[$in][1]": "Rejected",
    });
    const waitingCancelParams = buildParams(baseInProcessStatus, buyerFilter, {
      "cancel_status[$in][0]": "Waiting for Approval",
      "cancel_status[$in][1]": "Waiting for Procurement Approval",
    });

    const inProcessGR = await $api.v_po_billings.getPoBillings(
      inProcessParams
    );
    commit("setInProcessGRCounter", inProcessGR?.total || 0);

    const waitingCancelGR = await $api.v_po_billings.getPoBillings(
      waitingCancelParams
    );
    commit(
      "setWaitingForCancelApprovedGRCounter",
      waitingCancelGR?.total || 0
    );

    const waitingForApprovalParams = buildParams(
      {
        status: "Waiting for Approval",
        is_active: true,
      },
      buyerFilter
    );
    const waitingForApprovalGR = await $api.v_po_billings.getPoBillings(
      waitingForApprovalParams
    );
    commit(
      "setWaitingForApprovalGRCounter",
      waitingForApprovalGR?.total || 0
    );

    const blockedInvoiceParams = buildParams(
      {
        status: "Waiting for Payment",
        blocked_invoice: true,
        is_active: true,
      },
      buyerFilter
    );
    const blockedInvoiceGR = await $api.v_po_billings.getPoBillings(
      blockedInvoiceParams
    );
    commit("setBlockedInvoiceGRCounter", blockedInvoiceGR?.total || 0);

    commit(
      "setTotalGR",
      state.totalGR.inProcess +
        state.totalGR.waitingForApproval +
        state.totalGR.blockedInvoice +
        state.totalGR.waitingForCancelApproved
    );
  }
};

export default { state, getters, mutations, actions };
